import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

const MileageKmMin = withFilterContext(FilterName.min_mileage_km, SearchFiltersDropdown, {
    title: rangeMin.title,
    ariaLabel: ariaLabel.mileage.min,
})

const MileageKmMax = withFilterContext(FilterName.max_mileage_km, SearchFiltersDropdown, {
    title: rangeMax.title,
    ariaLabel: ariaLabel.mileage.max,
})

export const MileageKmMinFacetAndFilter = withFacetContext(FacetName.mileage_km, MileageKmMin)

export const MileageKmMaxFacetAndFilter = withFacetContext(FacetName.mileage_km, MileageKmMax)
